import React from 'react';
import dynamic from 'next/dynamic';
import { BreadCrumbs, Container } from '@/containers';
import { Title, Loader } from '@/components';
import getLinkProps from '@/lib/getLinkProps';

import styles from './ContactsPage.module.scss';

const Contacts = dynamic(() => import('../../components/contacts'), {
	loading: () => <Loader />,
});

const ContactsPage = () => {
	const [contactsHref, _contactsAs, contactsTitle] = getLinkProps({ type: 'contacts' });
	const breadCrumbsСontacts = [{ slug: contactsHref, name: contactsTitle }];

	return (
		<section className={styles.section}>
			<Container>
				<div className={styles.breadCrumbs}>
					<BreadCrumbs type='news' breadcrumbs={breadCrumbsСontacts} />
				</div>

				<Title component='h1' mb='large'>
					Наши контакты
				</Title>
			</Container>
			<Contacts />
		</section>
	);
};

export default ContactsPage;
